export enum LayerStatus {
	Error = "Error",
	Uploading = "Uploading",
	Processing = "Processing",
	Loading = "Loading",
	ProcessedAndLoaded = "ProcessedAndLoaded",
}
